import { render, staticRenderFns } from "./TableExtra.vue?vue&type=template&id=001a4708&scoped=true&"
import script from "./TableExtra.vue?vue&type=script&lang=js&"
export * from "./TableExtra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001a4708",
  null
  
)

export default component.exports